type TReadinessState = Record<string, never>

export const getInitialReadinessState = (): TReadinessState => {
    return {}
}

const moduleState = getInitialReadinessState()

export default moduleState
